import { z } from 'zod';

export const workersAndCompetenciesModuleSchema = z.object({}).default({});
